import { Box, BoxProps, Button } from "@chakra-ui/react";
import { Gender } from "common";
import { IoMdMale, IoMdFemale } from "react-icons/io";

interface GenderSelectorProps extends BoxProps {
  gender: Gender | null;
  setGender: (g: Gender | null) => void;
}

export const GenderSelector = ({
  gender,
  setGender,
  ...boxProps
}: GenderSelectorProps) => {
  return (
    <Box display={"flex"} justifyContent="center" width={"100%"} {...boxProps}>
      <Button
        borderRightRadius={0}
        aria-label="male"
        colorScheme={gender === "m" ? "blue" : undefined}
        onClick={() => (gender === "m" ? setGender(null) : setGender("m"))}
        width={"100%"}
        variant={gender === "m" ? undefined : "outline"}
      >
        <IoMdMale />
        <Box marginLeft={2}>Male</Box>
      </Button>
      <Button
        borderLeftRadius={0}
        aria-label="female"
        colorScheme={gender === "f" ? "pink" : undefined}
        onClick={() => (gender === "f" ? setGender(null) : setGender("f"))}
        width={"100%"}
        variant={gender === "f" ? undefined : "outline"}
      >
        <IoMdFemale />
        <Box marginLeft={2}>Female</Box>
      </Button>
    </Box>
  );
};
